import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Redirect, withRouter } from 'react-router'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import ProgressBar, {
  ProgressBarContainerWizard
} from 'src/components/atoms/ProgressBar'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import FormContainer from 'src/components/containers/FormContainer'
import PictureAnswer from 'src/components/atoms/wizard/PictureAnswer'
import { StoreProps } from 'src/stores'

const burial = require('src/assets/wizard/funeral_types/burial.png')
const burialSelected = require('src/assets/wizard/funeral_types/burial_selected.png')
const cremation = require('src/assets/wizard/funeral_types/cremation.png')
const cremationSelected = require('src/assets/wizard/funeral_types/cremation_selected.png')
const tree = require('src/assets/wizard/funeral_types/tree.png')
const treeSelected = require('src/assets/wizard/funeral_types/tree_selected.png')
const sea = require('src/assets/wizard/funeral_types/sea.png')
const seaSelected = require('src/assets/wizard/funeral_types/sea_selected.png')

interface State {
  valid: boolean
  noRedirect: boolean
}

@inject('wizardStore')
@observer
export class ImpendingFuneralType extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    const { wizardStore } = this.props
    const query = new URLSearchParams(location.search)
    this.state = {
      valid: !!wizardStore.basics.funeralType,
      noRedirect: !!query.get('editor')
    }
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_impendingFuneralType' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_impendingFuneralType' })
  }

  isChecked = (key) => {
    const { wizardStore } = this.props
    return key === wizardStore.basics.funeralType
  }

  handleAnswerClick = (key) => {
    const { wizardStore } = this.props
    if (this.isChecked(key)) {
      wizardStore.basics.funeralType = null
      this.setState({ valid: false })
    } else {
      wizardStore.basics.funeralType = key
      this.setState({ valid: true })
    }
  }

  renderAnswer = (key, text, pic, picSelected, startingPrice) => {
    return (
      <PictureAnswer
        answerKey={key}
        checked={this.isChecked(key)}
        onClick={() => this.handleAnswerClick(key)}
        picture={pic}
        pictureSelected={picSelected}>
        <p>{text}</p>
        <small>ab € {startingPrice}</small>
      </PictureAnswer>
    )
  }

  render() {
    const { wizardStore } = this.props
    const { valid, noRedirect } = this.state

    if (!wizardStore.basics.planningReason && !noRedirect)
      return <Redirect to='/planung/start/' />

    return (
      <WizardContainer>
        <Box>
          <ProgressBarContainerWizard>
            <ProgressBar start={10} end={40}>
              <p>
                <i className='fas fa-check'></i>
                Gut, dass Sie rechtzeitig vorausplanen. Dies entlastet
                maßgeblich bei Eintritt des Todesfalls!
              </p>
            </ProgressBar>
          </ProgressBarContainerWizard>
          <Question>Welche Bestattungsart wünschen Sie?</Question>
          <FormContainer flex='row'>
            {this.renderAnswer(
              'BURIAL',
              'Erdbestattung',
              burial,
              burialSelected,
              '2.005'
            )}
            {this.renderAnswer(
              'CREMATION',
              'Feuerbestattung',
              cremation,
              cremationSelected,
              '1.767'
            )}
            {this.renderAnswer(
              'TREE_FUNERAL',
              'Baumbestattung',
              tree,
              treeSelected,
              '1.788'
            )}
            {this.renderAnswer(
              'SEA_FUNERAL',
              'Donaubestattung',
              sea,
              seaSelected,
              '2.220'
            )}
          </FormContainer>
        </Box>
        <Navigation
          next={wizardStore.nextWizardStep}
          text='Weiter'
          disabled={!valid}
        />
      </WizardContainer>
    )
  }
}

export default withRouter(ImpendingFuneralType)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/impending/ImpendingFuneralType.tsx